import { ISelectOption } from '../../ui-toolkit';

export enum eVoidReason {
  IncorrectAccountNumber = 'Incorrect Account Number',
  IncorrectPayee = 'Incorrect Payee',
  IncorrectAmount = 'Incorrect Amount',
  IncorrectRoutingNumber = 'Incorrect Routing Number',
  FailedInWF = 'Failed in WF',
  SentInError = 'Sent in Error',
  Other = 'Other',
}

export const voidReasonOptions: ISelectOption<eVoidReason>[] = Object.entries(eVoidReason).map(([_, value]) => ({
  label: value.toString(),
  value: value,
}));

export enum eSentInErrorReasons {
  FundingNotAuthorized = 'Funding not Authorized',
  PendingIncomingFunds = 'Pending Incoming Funds',
  PendingCriticalDocuments = 'Pending Critical Documents',
  FileNotYetRecorded = 'File not yet Recorded',
  FundingError = 'Funding error',
}

export const sentInErrorReasonOptions: ISelectOption<eSentInErrorReasons>[] = Object.entries(eSentInErrorReasons).map(
  ([_, value]) => ({
    label: value.toString(),
    value: value,
  })
);
